module.exports = __webpack_public_path__ + "img/data.2ca49ea2.png";